
import { Component, Vue } from 'vue-property-decorator'

import RateChallengesTable from '@/components/admin/RateChallenges.vue'

@Component({
  components: {
    RateChallengesTable
  }
})
export default class RateChallenges extends Vue {

}
